import axios from 'axios'
import Cookies from 'js-cookie'
import auth from '../auth'

export default axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT2,
  //baseURL: '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'X-CSRFToken': Cookies.get('csrftoken'),
    'JWT': localStorage.getItem('token')
  }
})